import React, { Component } from "react";
import { connect } from "react-redux";
import "./PremiumMembership.css";
import {
  Col,
  Row,
  Card,
  Preloader,
  Button,
  Icon,
} from "react-materialize";
import { Link } from "react-router-dom";
import AuthComponent from "../../containers/AuthComponent";
import $ from "jquery";
import { changeSubscriptionActiveStatus } from "../../store/actions/authActions";
import { firebase } from "../../firebase/config";
import StripeCheckout from "../UI/StripeCheckout";
import { sendSubscriptionEvent } from "../../utils/analytics";
import { membershipUsdApproxWhole } from "../../utils/membershipBillingDisplay";


// Pricing tiers (amounts are AUD charged in Stripe)
const PRICING_TIERS = {
  basic: {
    price: "25",
    name: "Basic Membership",
    paypalButton: "YNKJMUC64MT5Q",
    stripePriceId: "price_1SXsQTE9mroRD7lKZAqvGZCD"
  },
  premium: {
    price: "50",
    name: "Premium",
    paypalButton: "PRUK4P42SGVDC",
    stripePriceId: "price_1SXVk6E9mroRD7lKIHxCKA7c"
  },
  premiumYearly: {
    price: "500",
    name: "Premium Yearly",
    paypalButton: null, // Stripe only
    stripePriceId: "price_1Ty20YE9mroRD7lKGkwa0WGd",
    period: "year"
  },
  // Partnership: two people, A$500/year each with A$100 off the FIRST year
  // (Paul, 10 Sep 2026: "$100 off the first year each, not every year").
  // Both tiers sit on full-price Stripe prices; the discount is a once-off
  // coupon carried by a hidden token the page attaches itself (see
  // getAppliedPromoToken), so renewals are list price. "Both" is one
  // A$1000 checkout (2 x A$500) covering the pair with a A$200 once coupon;
  // "half" is one person paying their own A$500 share with A$100 off.
  // price = what they pay today (first year); renewalPrice = every year after.
  // Names must contain "Premium" — the backend derives tier from tierName.
  premiumYearlyPartnerBoth: {
    price: "800",
    renewalPrice: "1000",
    name: "Premium Yearly Partnership",
    paypalButton: null,
    stripePriceId: "price_1UDukXE9mroRD7lKqyS1Q3SN", // A$1000/yr (2 x A$500), lookup_key partnership_both_2x500_yearly
    promoToken: "partnership-both-yearly", // userTokens: this price + A$200-once coupon Z6HXuIsS
    period: "year"
  },
  premiumYearlyPartnerHalf: {
    price: "400",
    renewalPrice: "500",
    name: "Premium Yearly Partnership",
    paypalButton: null,
    stripePriceId: "price_1Ty20YE9mroRD7lKGkwa0WGd", // the ordinary A$500/yr price
    promoToken: "partnership-half-yearly", // userTokens: this price + A$100-once coupon tiPPhEzc
    period: "year"
  }
};

const isPartnershipTier = (tier) =>
  tier === "premiumYearlyPartnerBoth" || tier === "premiumYearlyPartnerHalf";

// Headline unit on every plan card is the per-week rate (Paul, front-door
// review 2026-09-04): monthly x 12 / 52, yearly / 52. Stripe still bills the
// monthly or yearly amount; that sits on the "billed" line underneath.
const weeklyRate = (amount, period) =>
  (period === "year" ? Number(amount) / 52 : (Number(amount) * 12) / 52).toFixed(2);

const successCallback =
  "https://us-central1-bridgechampions.cloudfunctions.net/ipnHandler";
const processReturnBase =
  "https://us-central1-bridgechampions.cloudfunctions.net/process";
// A club code takes A$100 off the first year of Premium Yearly. Kept in step
// with the Stripe coupon behind userTokens/<code>-yearly (tiPPhEzc, A$100
// off, duration:once) - change both together or the page will promise a
// number Stripe does not honour.
const CLUB_YEARLY_DISCOUNT = 100;
const DEFAULT_TRIAL_TOKEN = "weekfree";
const DEFAULT_TRIAL_DAYS = 7;
const CLUB_YEARLY_PRICE = Number(PRICING_TIERS.premiumYearly.price) - CLUB_YEARLY_DISCOUNT;

const getRedirectToFromLocation = (location) => {
  const params = new URLSearchParams(location?.search || "");
  const redirectTo = params.get("redirectTo");
  return redirectTo && redirectTo.startsWith("/") ? redirectTo : "";
};

class PremiumMembership extends Component {
  state = {
    authComplete: false,
    showLogin: false,
    authChoice: null, // null = show chooser, 'login' | 'signup' = show that form
    alreadyLoggedIn: false,
    paypalRedirectLoading: false,
    selectedTier: null,
    token: undefined,
    promoCode: "",
    promoError: "",
    promoSuccess: "",
    // Set when a YEARLY promo (klinger, clubhouse) is applied: the discounted yearly
    // total. While set, only the Premium Yearly card is offered — the generic
    // promo plumbing assumes monthly prices and would render "A$400/month".
    promoYearlyPrice: null,
    // Set when a CLUB code is applied. Club codes are dual-purpose: a free
    // month on Basic/Premium, or A$100 off the first year. Unlike
    // promoYearlyPrice this must NOT hide the other tiers — the whole point is
    // that the reader picks the plan they want and the one code covers both.
    promoClubYearlyPrice: null,
    // Partnership card state: who pays, and the partner's name (required —
    // recorded on the members doc so Paul knows who the pair is).
    partnershipPayOption: "both",
    partnerName: "",
    partnerNameError: "",
    stripeProcessing: false,
    effectiveStripePriceId: null, // Override from promo (e.g. ausyouth = A$20/mo)
    effectiveMonthlyPrice: null,
    promoDaysFree: 0, // From last successful validation (for copy: free days vs price promo)
    referralCodeFromLink: "",
    referralReferrerUid: "",
    referralReferrerName: "",
    referralLookupDone: false,
    referralAttributionSaved: false,
  };

  componentDidMount() {
    // Let both logged-in and logged-out users see the subscription page (no redirect to /signup)
    this.loadReferralFromQuery();
    this.applyPlanFromQuery();
  }

  // ?plan=yearly (the "Best value" buttons for free accounts, 25 Sep 2026) opens straight on
  // Premium Yearly: signed in -> that plan is selected; signed out -> the login step for it.
  applyPlanFromQuery = () => {
    if (this.planFromQueryApplied) return;
    const q = new URLSearchParams((this.props.location && this.props.location.search) || "");
    if (q.get("plan") !== "yearly") return;
    if (!this.props.authReady) return;
    this.planFromQueryApplied = true;
    if (this.props.uid) this.selectTier("premiumYearly");
    else this.showLogin("premiumYearly");
  };

  componentDidUpdate(prevProps) {
    if (!this.planFromQueryApplied && (prevProps.authReady !== this.props.authReady || prevProps.uid !== this.props.uid)) {
      this.applyPlanFromQuery();
    }
    // When user logs out while on this page, just re-render (show tier cards again)
    if (prevProps.uid && !this.props.uid) {
      this.setState({ showLogin: false, authChoice: null, referralAttributionSaved: false });
    }
    if (prevProps.location?.search !== this.props.location?.search) {
      this.loadReferralFromQuery();
    }
    if (this.props.uid && !this.state.referralAttributionSaved && this.isReferralPremiumOfferActive()) {
      this.persistReferralAttribution();
    }
    if (this.isReferralPremiumOfferActive() && this.state.selectedTier === "basic") {
      this.setState({ selectedTier: "premium" });
    }
  }

  normalizeReferralCode = (code) => String(code || "").replace(/\s+/g, "").trim().toUpperCase();

  isReferralPremiumOfferActive = () =>
    !!(this.state.referralCodeFromLink && this.state.referralReferrerUid);

  getReferrerName = (data) => {
    const first = String(data?.firstName || "").trim();
    const last = String(data?.surname || "").trim();
    const displayName = [first, last].filter(Boolean).join(" ").trim();
    if (displayName) return displayName;
    const fallback = String(data?.displayName || "").trim();
    if (fallback) return fallback;
    const email = String(data?.email || "").trim();
    if (email) return email;
    return "a Bridge Champions member";
  };

  loadReferralFromQuery = async () => {
    const search = this.props.location?.search || "";
    const params = new URLSearchParams(search);
    const codeFromUrl = this.normalizeReferralCode(params.get("ref"));
    if (!codeFromUrl) {
      this.setState({
        referralCodeFromLink: "",
        referralReferrerUid: "",
        referralReferrerName: "",
        referralLookupDone: true,
      });
      return;
    }

    try {
      // Server-side lookup (content-app /api/resolve-referral, Admin SDK).
      // Was a direct client query on members, which forced that collection to
      // be world-readable — a PII leak. Rules now lock members to own-doc.
      const res = await fetch("/api/resolve-referral", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code: codeFromUrl }),
      });
      const found = res.ok ? await res.json() : { found: false };
      if (!found || !found.found) {
        this.setState({
          referralCodeFromLink: "",
          referralReferrerUid: "",
          referralReferrerName: "",
          referralLookupDone: true,
        });
        return;
      }
      this.setState({
        referralCodeFromLink: codeFromUrl,
        referralReferrerUid: found.uid,
        referralReferrerName: found.name || "a Bridge Champions member",
        referralLookupDone: true,
      });
    } catch (err) {
      console.error("Failed to resolve referral code from URL", err);
      this.setState({
        referralCodeFromLink: "",
        referralReferrerUid: "",
        referralReferrerName: "",
        referralLookupDone: true,
      });
    }
  };

  persistReferralAttribution = async () => {
    const { uid } = this.props;
    if (!uid || !this.isReferralPremiumOfferActive()) return;
    if (uid === this.state.referralReferrerUid) {
      this.setState({ referralAttributionSaved: true });
      return;
    }
    try {
      await firebase
        .firestore()
        .collection("members")
        .doc(uid)
        .set(
          {
            referredByCode: this.state.referralCodeFromLink,
            referredByUid: this.state.referralReferrerUid,
            referredByName: this.state.referralReferrerName || "",
            referredAt: firebase.firestore.FieldValue.serverTimestamp(),
          },
          { merge: true }
        );
      this.setState({ referralAttributionSaved: true });
    } catch (err) {
      console.error("Failed to save referral attribution", err);
    }
  };


  handlePromoCodeChange = (e) => {
    const promoCode = e.target.value.toLowerCase();
    this.setState({
      promoCode,
      promoError: "",
      promoSuccess: "",
      effectiveStripePriceId: null,
      effectiveMonthlyPrice: null,
      promoDaysFree: 0,
      promoYearlyPrice: null,
      promoClubYearlyPrice: null,
    });

    // Validate promo code after user stops typing (debounce)
    if (this.promoTimeout) clearTimeout(this.promoTimeout);
    
    if (promoCode.length > 0) {
      this.promoTimeout = setTimeout(() => {
        this.validatePromoCode(promoCode);
      }, 500);
    }
  };

  validatePromoCodeNow = (rawCode) => {
    const promoCode = String(rawCode || "").toLowerCase().trim();
    if (this.promoTimeout) clearTimeout(this.promoTimeout);
    if (!promoCode) {
      this.validatePromoCode("");
      return;
    }
    this.validatePromoCode(promoCode);
  };

  handlePromoCodeKeyDown = (e) => {
    if (e.key !== "Enter") return;
    e.preventDefault();
    this.validatePromoCodeNow(this.state.promoCode);
  };

  handlePromoCodeBlur = () => {
    this.validatePromoCodeNow(this.state.promoCode);
  };

  normalizePromoCode = (code) => String(code || "").toLowerCase().replace(/\s+/g, "").trim();
  isPremiumOnlyFreeMonthPromo = (code) => {
    // "easts" left this list on 2026-09-15 - it is a club code now (own token docs).
    // "klinger" left on 2026-09-23 (Paul: "give 100 off yearly, but nothing to monthly"): it used to be
    // aliased to BLUE here, which gave a free Premium month and never reached its own yearly token.
    // It now resolves to userTokens/klinger (A$500 price + A$100-once coupon) via isYearlyPromoCode only.
    return false;
  };

  // AUGUST400 (August 2026 offer): A$400 for the first year of Premium Yearly.
  // Yearly codes get their own display path — see promoYearlyPrice in state.
  // Codes that buy a YEAR of Premium, so the page shows the yearly card only
  // and reads the token's price as a yearly total rather than a monthly rate.
  // CLUBHOUSE (2026-09-03) is Paul's personal code for friends: Premium Yearly
  // at A$300/year, every year, after a 30-day free trial. It belongs on this
  // list precisely BECAUSE the list collapses the page to the yearly card —
  // the code is yearly-only, and its Firestore token overrides the checkout
  // price. That override is unconditional in the backend, so letting it reach
  // a monthly checkout would silently move the buyer onto a yearly plan.
  isYearlyPromoCode = (code) =>
    // nzcongress (21 Sep 2026): NZ National Congress programme book, 20% off year one, coupon expires 15 Nov 2026.
    // nsw400 (22 Sep 2026): Bridge NSW newsletter readers, 20% off year one (userTokens/nsw400 = A$500
    // price + A$100-once coupon). Paul: yearly only, the code must do nothing on a monthly plan.
    // worldchamps (22 Sep 2026): neutral code on the World Championships magazine piece (ABF Newsletter
    // first), 20% off year one, no expiry.
    // glenelg400 (22 Sep 2026): Glenelg Contract Bridge Club members (Pam Murphy, committee), 20% off year one, no expiry.
    // nsbc400 (23 Sep 2026): Northern Suburbs Bridge Club, Hendra Brisbane (Denise Taylor, committee),
    // on the two newsletter pieces sent with Paul's email. 20% off year one, no expiry, nothing on monthly.
    // easts (29 Sep 2026): Easts Bridge Club (Terry Simmons). Paul: A$100 off year one of Premium Yearly, nothing on
    // monthly ("the main form of membership I'm offering"). userTokens/easts = A$500 price + A$100-once coupon tiPPhEzc.
    // welcomeback (30 Sep 2026): win-back offer emailed to former paying members. A$100 off year one of Premium
    // Yearly, nothing on monthly. Coupon WELCOMEBACK100 expires end of 3 Oct 2026 - REMOVE this entry and delete
    // userTokens/welcomeback after that.
    // springnats (12 Oct 2026): Spring Nationals 2026 bulletin advert, 20% off year one, coupon SPRINGNATS20 expires
    // end of 30 Nov 2026 - REMOVE this entry and delete userTokens/springnats after that.
    // pair200 (13 Oct 2026): private second-of-a-pair code, A$200 off year one of Premium Yearly. Missing from this
    // list it showed "A$300 billed monthly" on the Premium card (Martin Brown spotted it, 14 Oct 2026).
    ["klinger", "travis27", "clubhouse", "nzcongress", "springnats", "pair200", "nsw400", "worldchamps", "wabc400", "glenelg400", "nsbc400", "easts", "welcomeback"].includes(this.normalizePromoCode(code));

  // CLUB CODES (from 2026-08-31). One code printed on one flyer has to cover
  // whichever plan the reader wants, because a newsletter can't ask them to
  // remember two. So each club code is backed by TWO Firestore tokens:
  //
  //   userTokens/<code>          daysFree:30            → Basic or Premium
  //   userTokens/<code>-yearly   A$500 price + coupon   → A$100 off year one
  //
  // The frontend picks the token from the tier the reader selected. That keeps
  // this entirely in the browser — no backend change, no function deploy —
  // because createCheckoutSession already reads whichever token id it is given.
  //
  // A club code is deliberately NOT in isYearlyPromoCode: that list collapses
  // the page down to the yearly card only, which would hide the free month.
  clubPromoCodes = () => [
    "nzb400",
    "tt400",
    "ndbc400",
    "gw400",
    "imp400",
    "scc400",
    "probus400",
    "slu400",
    "mwb400",
    "tam27",
    "agnes400",
    "richmond400",
    // WABC400 was a club code from 31 Aug to 22 Sep 2026; it is now yearly-only (isYearlyPromoCode).
    "maccabi400",
    "hamam400",
    "afpop",
    "ubsf400",
    "coogee400",
    "sgcc400",
    // EASTS was a club code from 15 to 29 Sep 2026; it is now yearly-only (isYearlyPromoCode).
    // TRUMPS (Trumps Bridge Centre, Derrick) became a club code on 2026-09-15 for the
    // 11 October birthday-event flyer: free month on either plan, or A$100 off the first
    // year (userTokens/trumps + userTokens/trumps-yearly). Before that it was free-month only.
    "trumps",
    // LEON2027 (Leon Meier, 16 Sep 2026): printed on his two flyers - free month on either plan,
    // or A$100 off the first year (userTokens/leon2027 + userTokens/leon2027-yearly).
    "leon2027",
    // NSW400 was a club code from 18 to 22 Sep 2026; it is now yearly-only (isYearlyPromoCode).
  ];

  isClubPromoCode = (code) => this.clubPromoCodes().includes(this.normalizePromoCode(code));

  /** The A$100-off-yearly half of a club code. */
  clubYearlyToken = (code) => `${this.normalizePromoCode(code)}-yearly`;

  // Whether a yearly code's discounted rate REPEATS or applies once. This is
  // not cosmetic: it decides what the page tells a buyer they will pay next
  // year. A code that overrides the checkout price (clubhouse -> the A$300
  // price) recurs forever; a code that carries a duration:once coupon
  // (klinger, travis27, the club codes) discounts only the first invoice and renews at
  // list. Getting this backwards means the page states a price Stripe will not
  // charge, which is exactly the bug that made a member abandon checkout twice
  // on 31 Aug 2026. Audit with scripts/_audit-promo-tokens.js.
  recurringYearlyPromoCodes = () => ["clubhouse"];

  isRecurringYearlyPromoCode = (code) =>
    this.recurringYearlyPromoCodes().includes(this.normalizePromoCode(code));

  /** Months free vs paying monthly, for whatever yearly price is on display.
   *  A$500 buys 12 months for the price of 10, so 2 free; a A$300 code is 6.
   *  Hardcoding 4 (right only for the A$400 club codes) misstates every other. */
  yearlyMonthsFree = () => {
    const yearly = Number(this.yearlyDisplayPrice() != null
      ? this.yearlyDisplayPrice()
      : PRICING_TIERS.premiumYearly.price);
    const monthly = Number(PRICING_TIERS.premium.price);
    const free = 12 - yearly / monthly;
    return Number.isFinite(free) && free > 0 ? Math.round(free) : 2;
  };

  /** Yearly total to DISPLAY: a dedicated yearly code, or the club-code discount. */
  yearlyDisplayPrice = () =>
    this.state.promoYearlyPrice != null
      ? this.state.promoYearlyPrice
      : this.state.promoClubYearlyPrice;

  resolvePromoCodeAlias = (code) => {
    const normalized = this.normalizePromoCode(code);
    // KLINGER was aliased to BLUE (free Premium month) until 2026-09-23; it now has its own
    // userTokens/klinger doc (yearly, A$100 off year one) and is never aliased.
    // (EASTS was un-aliased 2026-09-15: it has its own docs and is a club code.)
    if (this.isPremiumOnlyFreeMonthPromo(normalized)) return "blue";
    // HARBOURVIEW is NOT aliased: it has its own userTokens/harbourview doc
    // (daysFree:30) AND a hardcoded backend safety net keyed on the literal string
    // "harbourview". Aliasing it to BLUE broke both — BLUE has no Firestore doc and
    // no backend handling, so the checkout fell through to an immediate charge
    // instead of a free month. Never alias a code that has its own token doc.
    if (
      normalized === "pete26" ||
      normalized === "welcome2026" ||
      normalized === "milne"
    ) {
      return "blue";
    }
    // Firestore document ids are normalized lowercase promo codes.
    return normalized;
  };

  isOneMonthFreeAnyTierCode = (code) => {
    const normalized = this.normalizePromoCode(code);
    return (
      normalized === "blue" ||
      normalized === "trumps" ||
      normalized === "abc26" ||
      normalized === "pete26" ||
      normalized === "welcome2026" ||
      normalized === "milne" ||
      normalized === "harbourview" ||
      normalized === "cbc" ||
      normalized === "gill" ||
      normalized === "3teams" ||
      normalized === "jess26" ||
      normalized === "vcc26" ||
      this.isClubPromoCode(normalized)
    );
  };

  /** Trial-extension promos — standard monthly price unchanged (unlike ausyouth price override). */
  isExtendedTrialStandardPricePromo = (code) => {
    const normalized = this.normalizePromoCode(code);
    return (
      normalized === "blue" ||
      normalized === "trumps" ||
      normalized === "abc26" ||
      normalized === "pete26" ||
      normalized === "welcome2026" ||
      normalized === "milne" ||
      normalized === "harbourview" ||
      normalized === "cbc" ||
      normalized === "goldy" ||
      normalized === "gill" ||
      normalized === "3teams" ||
      normalized === "jess26" ||
      normalized === "vcc26" ||
      this.isClubPromoCode(normalized)
    );
  };

  getAppliedPromoToken = () => {
    if (this.isReferralPremiumOfferActive()) {
      return this.state.selectedTier === "premium" ? "blue" : null;
    }
    const normalized = this.normalizePromoCode(this.state.promoCode);
    // KLINGER is Premium-only. Never send it through Basic checkout.
    if (this.isPremiumOnlyFreeMonthPromo(normalized) && this.state.selectedTier !== "premium") {
      return null;
    }
    const enteredCode = this.resolvePromoCodeAlias(this.state.promoCode);
    // Partnership carries its own hidden token (full-price Stripe price plus a
    // once-off coupon, so year one is discounted and renewals are list). A
    // typed code or the default trial token must never replace it: a trial
    // would make the first invoice A$0 and the once-off coupon would be spent
    // against nothing (scripts/_audit-promo-tokens.js, TRAP 1).
    if (isPartnershipTier(this.state.selectedTier)) {
      return PRICING_TIERS[this.state.selectedTier].promoToken;
    }
    // Yearly is charged straight away — no trial, so never send the default
    // trial token with it. An explicitly entered code still passes through
    // (yearly promo codes such as klinger carry their own terms).
    if (this.state.selectedTier === "premiumYearly") {
      // A club code on the yearly plan means the A$100-off token, not the
      // free-month one. Sending the free-month token here would set a 30-day
      // trial on a plan that is supposed to be charged today.
      if (this.isClubPromoCode(normalized)) return this.clubYearlyToken(normalized);
      return enteredCode || null;
    }
    return enteredCode || DEFAULT_TRIAL_TOKEN;
  };

  /** Normalize API payload (Express was previously sending wrong body; keep defensive). */
  parseValidateTokenPayload = (data) => {
    let obj = data;
    if (typeof obj === "string") {
      try {
        obj = JSON.parse(obj);
      } catch (e) {
        return { monthlyPrice: null, stripePriceId: null, daysFree: 0, tier: undefined };
      }
    }
    if (!obj || typeof obj !== "object") {
      return { monthlyPrice: null, stripePriceId: null, daysFree: 0, tier: undefined };
    }
    const rawMp = obj.monthlyPrice;
    const monthlyPrice =
      rawMp === undefined || rawMp === null || rawMp === ""
        ? null
        : Number(rawMp);
    const coercedMp = Number.isFinite(monthlyPrice) ? monthlyPrice : null;
    const daysNum = Number(obj.daysFree);
    const daysFree = Number.isFinite(daysNum) && daysNum > 0 ? daysNum : 0;
    return {
      ...obj,
      monthlyPrice: coercedMp,
      stripePriceId: obj.stripePriceId || null,
      daysFree,
      tier: obj.tier,
    };
  };

  validatePromoCode = (code) => {
    if (!code) {
      this.setState({ promoError: "", promoSuccess: "", promoDaysFree: 0, promoYearlyPrice: null, promoClubYearlyPrice: null });
      return;
    }

    // Use the backend validator so UI always matches what checkout will do.
    const url = "https://us-central1-bridgechampions.cloudfunctions.net/validateUserToken";
    const codeForValidation = this.resolvePromoCodeAlias(code);
    $.ajax({
      url,
      method: "POST",
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      data: `token=${encodeURIComponent(codeForValidation)}`,
      dataType: "json",
    })
      .then((raw) => {
        const data = this.parseValidateTokenPayload(raw);
        const days = data.daysFree;
        const tier = this.isPremiumOnlyFreeMonthPromo(code) ? "premium" : data.tier;

        const nextStep = " Choose a subscription below and complete checkout to apply it.";
        const monthlyPrice = data.monthlyPrice;
        const stripePriceId = data.stripePriceId;

        // Yearly promo: the token's price is a YEARLY total, not a monthly rate.
        // Show accurate yearly wording and steer the page to the yearly card only.
        if (this.isYearlyPromoCode(code) && stripePriceId) {
          const yearlyTotal = monthlyPrice != null ? monthlyPrice : 400;
          this.setState({
            promoError: "",
            promoSuccess: days > 0
              ? `✓ Code valid! Premium Yearly at A$${yearlyTotal} for the year (normally A$${PRICING_TIERS.premiumYearly.price}), and your first ${days} days are free. You pay A$0 today — your first charge is in ${days} days. Complete checkout below to apply it.`
              : `✓ Code valid! Premium Yearly at A$${yearlyTotal} for the year (normally A$${PRICING_TIERS.premiumYearly.price}). Complete checkout below to apply it.`,
            effectiveStripePriceId: stripePriceId,
            effectiveMonthlyPrice: null,
            promoDaysFree: days || 0,
            promoYearlyPrice: yearlyTotal,
            promoClubYearlyPrice: null,
            // If a monthly plan was mid-checkout, switch it: this code only
            // exists on the yearly plan, and the server would bill yearly anyway.
            ...(this.state.selectedTier && this.state.selectedTier !== "premiumYearly"
              ? { selectedTier: "premiumYearly" }
              : {}),
          });
          return;
        }

        if (tier && tier !== this.state.selectedTier) {
          const tierName = tier === "premium" ? "Premium" : "Basic";
          let detail = "";
          if (monthlyPrice != null) {
            const usdH = membershipUsdApproxWhole(monthlyPrice);
            const usdPart = usdH != null ? `, about US$${usdH}/month at typical FX` : "";
            detail = ` — billed at A$${monthlyPrice}/month after your ${DEFAULT_TRIAL_DAYS}-day free trial${usdPart} (your bank sets the rate)`;
          } else if (days > 0) {
            detail = ` (${days} free day${days !== 1 ? "s" : ""} before billing)`;
          }
          this.setState({
            promoError: "",
            promoSuccess: `✓ Code valid for ${tierName}.${detail}${nextStep}`,
            effectiveStripePriceId: stripePriceId || null,
            effectiveMonthlyPrice: monthlyPrice,
            promoDaysFree: days,
            promoYearlyPrice: null,
            promoClubYearlyPrice: this.isClubPromoCode(code) ? CLUB_YEARLY_PRICE : null,
          });
        } else {
          let msg;
          if (days > 0 && this.isClubPromoCode(code)) {
            // Both halves of a club code, spelled out, because the flyer
            // promised both and the reader has not chosen a plan yet.
            msg =
              `✓ Code valid! 1 month free on Basic or Premium, ` +
              `or A$${CLUB_YEARLY_PRICE} for the first year of Premium Yearly ` +
              `(normally A$${PRICING_TIERS.premiumYearly.price}).${nextStep}`;
          } else if (days > 0 && this.isOneMonthFreeAnyTierCode(code)) {
            msg = `✓ Code valid! 1 month free with Standard or Premium.${nextStep}`;
          } else if (days > 0) {
            msg = `✓ Code valid! ${days} free day${days !== 1 ? "s" : ""} before billing.${nextStep}`;
          } else if (monthlyPrice != null) {
            const usdH = membershipUsdApproxWhole(monthlyPrice);
            const usdPart = usdH != null ? ` (about US$${usdH}/month at typical FX; your bank sets the rate)` : "";
            msg = `✓ Code valid! Your Premium rate will be A$${monthlyPrice}/month after the ${DEFAULT_TRIAL_DAYS}-day free trial${usdPart}.${nextStep}`;
          } else {
            msg = `✓ Code valid!${nextStep}`;
          }
          this.setState({
            promoSuccess: msg,
            promoError: "",
            effectiveStripePriceId: stripePriceId || null,
            effectiveMonthlyPrice: monthlyPrice,
            promoDaysFree: days,
            promoYearlyPrice: null,
            promoClubYearlyPrice: this.isClubPromoCode(code) ? CLUB_YEARLY_PRICE : null,
          });
        }
      })
      .catch((err) => {
        console.error("Error validating promo code:", err);
        this.setState({
          promoError: "Invalid promo code",
          promoSuccess: "",
          effectiveStripePriceId: null,
          effectiveMonthlyPrice: null,
          promoDaysFree: 0,
          promoYearlyPrice: null,
        });
      });
  };

  componentWillUpdate(nextProps) {
    let whenSubExpiresMinus2Days = undefined;
    if (nextProps.subscriptionExpires) {
      whenSubExpiresMinus2Days =
        new Date(nextProps.subscriptionExpires).getTime() -
        2 * 24 * 60 * 60 * 1000;
      if (nextProps.subscriptionActive && new Date() < whenSubExpiresMinus2Days) {
        this.props.history.push(getRedirectToFromLocation(this.props.location) || "/");
      }
    }

    if (nextProps.uid && !this.state.alreadyLoggedIn) {
      this.setState({ alreadyLoggedIn: true });
    }
  }

  showLogin = (tier) => {
    if (this.isReferralPremiumOfferActive() && tier !== "premium") {
      this.setState({ showLogin: true, authChoice: null, selectedTier: "premium" });
      return;
    }
    this.setState({ showLogin: true, authChoice: null, selectedTier: tier });
  };

  selectTier = (tier) => {
    if (this.isReferralPremiumOfferActive() && tier !== "premium") {
      this.setState({ selectedTier: "premium" });
      return;
    }
    this.setState({ selectedTier: tier });
  };

  // Record who the partner is on the payer's members doc (merge; own doc —
  // same write pattern as the promo-code audit). Purely for Paul's records.
  recordPartnershipDetails = () => {
    const name = this.state.partnerName.trim();
    if (!this.props.uid || !name) return;
    firebase
      .firestore()
      .collection("members")
      .doc(this.props.uid)
      .set(
        {
          partnershipPartnerName: name,
          partnershipPayOption: this.state.partnershipPayOption,
          partnershipCheckoutStartedAt: firebase.firestore.FieldValue.serverTimestamp(),
        },
        { merge: true }
      )
      .catch((e) => console.error("Failed to record partnership details", e));
  };

  selectPartnershipTier = () => {
    const name = this.state.partnerName.trim();
    if (!name) {
      this.setState({ partnerNameError: "Please add your partner's name first." });
      return;
    }
    this.setState({ partnerNameError: "" });
    const tier =
      this.state.partnershipPayOption === "half"
        ? "premiumYearlyPartnerHalf"
        : "premiumYearlyPartnerBoth";
    if (this.props.uid) {
      this.recordPartnershipDetails();
      this.selectTier(tier);
    } else {
      this.showLogin(tier);
    }
  };

  paypalSubscribe = async (uid, redirect = false) => {
    if (!redirect || !this.state.selectedTier) {
      this.setState({ showLogin: false });
      return;
    }
    this.setState({
      authComplete: true,
      showLogin: false,
      paypalRedirectLoading: true,
    });

    const tier = PRICING_TIERS[this.state.selectedTier];
    const paypalUrl = `https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=${tier.paypalButton}`;
    let returnUrl = `${processReturnBase}?uid=${encodeURIComponent(uid)}`;
    const redirectAfterCheckout = getRedirectToFromLocation(this.props.location);
    if (redirectAfterCheckout) {
      try {
        localStorage.setItem("postCheckoutRedirectTo", redirectAfterCheckout);
      } catch (e) {
        // ignore
      }
    }
    const appliedToken = this.getAppliedPromoToken();
    if (appliedToken) {
      returnUrl = returnUrl + "&promo=" + encodeURIComponent(appliedToken);
    }
    const url = `${paypalUrl}&notify_url=${encodeURIComponent(successCallback)}&custom=${encodeURIComponent(uid)}&return=${encodeURIComponent(returnUrl)}`;
    window.location = url;
  };

  signupClicked = (e) => {
    e.preventDefault();
    this.setState({ authComplete: true });
    this.paypalSubscribe(this.props.uid, true);
  };

  handleUpgradeClick = () => {
    const { paymentMethod, uid } = this.props;
    if (!uid) return;
    this.setState({ paypalRedirectLoading: true });
    if (paymentMethod === "paypal") {
      const paypalUrl = `https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=${PRICING_TIERS.premium.paypalButton}`;
      const returnUrl = `${processReturnBase}?uid=${encodeURIComponent(uid)}&upgraded=1`;
      const url = `${paypalUrl}&notify_url=${encodeURIComponent(successCallback)}&custom=${encodeURIComponent(uid)}&return=${encodeURIComponent(returnUrl)}`;
      window.location.href = url;
      return;
    }
    const stripeUpgradeUrl = "https://us-central1-bridgechampions.cloudfunctions.net/stripeUpgradeSubscription";
    $.post(stripeUpgradeUrl, { uid })
      .done((data) => {
        this.setState({ paypalRedirectLoading: false });
        const source = typeof sessionStorage !== "undefined" ? sessionStorage.getItem("subscription_upgrade_source") : null;
        sendSubscriptionEvent("subscription_upgraded", {
          from_tier: "basic",
          to_tier: "premium",
          upgrade_source: source || "membership_page",
        });
        if (typeof sessionStorage !== "undefined") sessionStorage.removeItem("subscription_upgrade_source");
        this.props.changeSubscriptionActiveStatus(true);
        window.location.reload();
      })
      .fail(() => {
        this.setState({ paypalRedirectLoading: false });
        alert("Upgrade failed. Please try again or contact support.");
      });
  };

  render() {
    const { selectedTier, showLogin, authComplete, paypalRedirectLoading } = this.state;
    const { uid, subscriptionActive, authReady } = this.props;
    const referralPremiumOfferActive = this.isReferralPremiumOfferActive();
    const referralReferrerName = this.state.referralReferrerName || "a Bridge Champions member";

    // Show "already subscribed" message for any active subscriber
    if (uid && subscriptionActive && authReady) {
      const tierName = this.props.tier === "premium" ? "Premium" : "Basic";
      const isBasic = this.props.tier === "basic";
      const redirectTo = getRedirectToFromLocation(this.props.location);
      return (
        <div className="PremiumMembership-container">
          <Card className="PremiumMembership-pricing-card" style={{ maxWidth: "32rem", margin: "4rem auto", padding: "2rem", textAlign: "center" }}>
            <div style={{ fontSize: "3rem", marginBottom: "1rem", color: "#2e7d32" }}><Icon>check_circle</Icon></div>
            <h4 style={{ marginBottom: "0.75rem" }}>You're already subscribed</h4>
            <p style={{ color: "#555", marginBottom: "1.5rem" }}>
              You have an active {tierName} subscription. {!isBasic && "There's no need to subscribe again — you have full access to all your content."}
              {isBasic && "Upgrade to Premium for exclusive videos and more."}
            </p>
            {isBasic && (
              <Button
                waves="light"
                onClick={this.handleUpgradeClick}
                disabled={this.state.paypalRedirectLoading}
                style={{ backgroundColor: "#0F4C3A", marginBottom: "1rem" }}
              >
                {this.state.paypalRedirectLoading ? "Redirecting…" : "Upgrade to Premium"}
              </Button>
            )}
            {/* Yearly for Basic members too (Paul, 25 Sep 2026), same two-click page as the Game Plan bar. */}
            {isBasic && (
              <Button
                waves="light"
                onClick={() => this.props.history.push("/go-yearly")}
                style={{ backgroundColor: "#c9a227", color: "#2b2100", marginBottom: "1rem", marginLeft: "0.5rem" }}
              >
                Best value: Premium Yearly, A$500 a year
              </Button>
            )}
            <Button waves="light" onClick={() => this.props.history.push(redirectTo || "/")} style={{ backgroundColor: isBasic ? "#666" : "#0F4C3A" }}>
              {redirectTo ? "Continue to the trainer questions" : "Go to homepage"}
            </Button>
          </Card>
        </div>
      );
    }

    const showTierSelection = uid && selectedTier && !authComplete;
    const showBothTiers = !authReady || (!uid && !showLogin) || (uid && !selectedTier && !authComplete);

    const paymentAudForFx =
      showTierSelection && selectedTier
        ? selectedTier === "premium" && this.state.effectiveMonthlyPrice != null
          ? this.state.effectiveMonthlyPrice
          : PRICING_TIERS[selectedTier].price
        : null;
    const paymentUsdForFx =
      paymentAudForFx != null ? membershipUsdApproxWhole(paymentAudForFx) : null;

    const normalizedPromoCode = this.normalizePromoCode(this.state.promoCode);
    const isBluePromoActive =
      this.isOneMonthFreeAnyTierCode(normalizedPromoCode) &&
      this.state.promoSuccess &&
      this.state.promoDaysFree > 0;
    const isPremiumOnlyPromoActive =
      this.isPremiumOnlyFreeMonthPromo(normalizedPromoCode) &&
      this.state.promoSuccess &&
      this.state.promoDaysFree > 0;
    const isFreeFirstMonthOnBasicCard = isBluePromoActive;
    const isFreeFirstMonthOnPremiumCard =
      isBluePromoActive || isPremiumOnlyPromoActive || referralPremiumOfferActive;
    // ONE place decides what the buyer is told about money, so the three places
    // that say it cannot drift apart from each other or from Stripe.
    const promoTrialDays =
      this.state.promoSuccess && this.state.promoDaysFree > 0 ? Number(this.state.promoDaysFree) : 0;
    const yearlyNowPrice = Number(
      this.yearlyDisplayPrice() != null ? this.yearlyDisplayPrice() : PRICING_TIERS.premiumYearly.price
    );
    const yearlyRenewalPrice = this.isRecurringYearlyPromoCode(normalizedPromoCode)
      ? yearlyNowPrice
      : Number(PRICING_TIERS.premiumYearly.price);
    const firstChargeDateStr = (() => {
      const d = new Date();
      d.setDate(d.getDate() + promoTrialDays);
      return d.toLocaleDateString("en-AU", { year: "numeric", month: "short", day: "numeric" });
    })();
    const selectedTierBasePrice =
      selectedTier && PRICING_TIERS[selectedTier]
        ? PRICING_TIERS[selectedTier].price
        : null;
    const isYearlySelected =
      !!selectedTier && PRICING_TIERS[selectedTier] && PRICING_TIERS[selectedTier].period === "year";
    const isPremiumOnlyPromoAppliedOnPremium =
      this.isPremiumOnlyFreeMonthPromo(normalizedPromoCode) &&
      selectedTier === "premium" &&
      this.state.promoSuccess &&
      this.state.promoDaysFree > 0;
    const isBlueAppliedOnSelectedTier =
      this.isOneMonthFreeAnyTierCode(normalizedPromoCode) &&
      this.state.promoSuccess &&
      this.state.promoDaysFree > 0 &&
      !!selectedTier;
    const isFreeFirstMonthAppliedOnSelectedTier =
      (referralPremiumOfferActive && selectedTier === "premium") ||
      isBlueAppliedOnSelectedTier ||
      isPremiumOnlyPromoAppliedOnPremium;
    const subscribePath = `${this.props.location.pathname || "/subscribe"}${this.props.location.search || ""}`;
    const redirectAfterCheckout = getRedirectToFromLocation(this.props.location);
    return (
      <div className="PremiumMembership-container">
        {showLogin && !uid && authReady && (
          <Row>
            <div className="PremiumMembership-authShell">
              {this.state.authChoice == null ? (
                <>
                  <p className="PremiumMembership-authPrompt">
                    Log in or create an account to continue with your subscription.
                  </p>
                  <div className="PremiumMembership-authCtaWrap">
                    <button
                      type="button"
                      className="PremiumMembership-authCta"
                      onClick={() => this.setState({ authChoice: "chooseAuthMethod" })}
                    >
                      Log in or Create Account
                    </button>
                  </div>
                  <p className="PremiumMembership-authCtaHint">Primary step: click the button above to continue.</p>
                  <p className="PremiumMembership-authBackLinkWrap">
                    <a
                      className="PremiumMembership-authBackLink"
                      href="#back"
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({ showLogin: false });
                      }}
                    >
                      ← Back to subscription options
                    </a>
                  </p>
                </>
              ) : this.state.authChoice === "chooseAuthMethod" ? (
                <>
                  <p className="PremiumMembership-authPrompt">
                    Choose how you want to continue:
                  </p>
                  <div className="PremiumMembership-authChoiceGrid">
                    <button
                      type="button"
                      className="PremiumMembership-authChoiceBtn"
                      onClick={() => this.setState({ authChoice: "login" })}
                    >
                      I have an existing login
                    </button>
                    <button
                      type="button"
                      className="PremiumMembership-authChoiceBtn PremiumMembership-authChoiceBtn--secondary"
                      onClick={() => this.setState({ authChoice: "signup" })}
                    >
                      I need to make a login
                    </button>
                  </div>
                  <p className="PremiumMembership-authBackLinkWrap">
                    <a
                      className="PremiumMembership-authBackLink"
                      href="#back"
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({ authChoice: null });
                      }}
                    >
                      ← Back
                    </a>
                  </p>
                </>
              ) : (
                <>
                  <p style={{ marginBottom: "0.5rem" }}>
                    <a href="#back" onClick={(e) => { e.preventDefault(); this.setState({ authChoice: "chooseAuthMethod" }); }}>
                      ← Back
                    </a>
                  </p>
                  <AuthComponent
                    signup={this.state.authChoice === "signup"}
                    login={this.state.authChoice === "login"}
                    location={this.props.location}
                    history={this.props.history}
                    redirectPathAfterAuth={subscribePath}
                    paypalSubscribe={() => this.setState({ showLogin: false, authChoice: null })}
                    switchToSignup={() => this.setState({ authChoice: "signup" })}
                    switchToLogin={() => this.setState({ authChoice: "login" })}
                  />
                </>
              )}
            </div>
          </Row>
        )}

        <div className="PremiumMembership-header">
          {!showLogin && (
            <span>
              <span className="PremiumMembership-title">Bridge Champions</span> &mdash; I like to
              work with my players over a full year. That&rsquo;s where the real improvement happens.
            </span>
          )}
          {referralPremiumOfferActive && (
            <div className="PremiumMembership-header_text" style={{ marginTop: "12px", color: "#0f4c3a" }}>
              You have been referred by <strong>{referralReferrerName}</strong>. You will get{" "}
              <strong>1 month of Premium free</strong> when you complete Premium signup.
            </div>
          )}

          {!showLogin && !authReady && (
            <div className="PremiumMembership-header_text_small" style={{ color: "#666" }}>
              Checking sign-in…
            </div>
          )}
          {!showLogin && !uid && authReady && (
            <div className="PremiumMembership-header_text_small">
              Monthly plans start with a {DEFAULT_TRIAL_DAYS}-day free trial. Already subscribed?&nbsp;
              <Link to="/login?redirect=content">Log in now</Link> to access premium content.
            </div>
          )}
        </div>

        {(this.state.alreadyLoggedIn || uid) && !showLogin && (
          <div className="PremiumMembership-header_text">
            Pick a plan below &mdash; yearly is where I can work with you the most. You must complete checkout to activate access.
          </div>
        )}

        {/* Proof, before the price: one member's words and who built the
            site (front-door review 2026-09-04). */}
        {!showLogin && (
          <Row>
            <Col s={12} m={10} l={8} offset="m1 l2">
              <figure className="PremiumMembership-proof">
                <blockquote>
                  I am absolutely loving your work! &hellip; It allows me to test myself with immediate
                  feedback from an expert&mdash;all done with compact, specific, and engaging comments.
                </blockquote>
                <figcaption>Ian Whyte, Newcastle</figcaption>
              </figure>
              <p className="PremiumMembership-proof-line">
                Built by Paul Dalley. 15 years studying and playing tournament bridge, represented Australia on the national team.
              </p>
            </Col>
          </Row>
        )}

        {/* PRICING CARDS (order since 21 Sep 2026, Paul): Premium Yearly first as "Paul's pick",
            then Premium and Basic side by side, then the Partnership plan and the promo box. */}
        {showBothTiers && (
          <Row>
            {/* PREMIUM YEARLY - FIRST, full width, "Paul's pick" (Paul, 21 Sep 2026). */}
            {!referralPremiumOfferActive && (
              <Col s={12}>
                <Card className="PremiumMembership-pricing-card PremiumMembership-pricing-card-yearly PremiumMembership-pricing-card--hero PremiumMembership-pricing-card--pick">
                  <div className="PremiumMembership-yearly-badge">
                    {this.yearlyDisplayPrice() != null
                      ? "BEST VALUE — CODE APPLIED, 4 MONTHS FREE"
                      : "BEST VALUE — 2 MONTHS FREE"}
                  </div>
                  {/* Paul, 21 Sep 2026: yearly at the top, clearly his pick. */}
                  <div className="PremiumMembership-pickWrap">
                    <span className="PremiumMembership-pick"><Icon className="PremiumMembership-pickStar">star</Icon>Paul&rsquo;s pick &middot; Recommended</span>
                  </div>
                  <h4 className="PremiumMembership-tier-name">Premium Yearly</h4>
                  {/* Weekly price leads; the yearly billing reality sits
                      quietly underneath (Paul: emphasise weekly, one line on
                      yearly, don't labour it). */}
                  <div className="PremiumMembership-price">
                    {/* With a code applied, show what the weekly rate was
                        before it, struck out — the saving should be visible on
                        the headline number, not only on the billed line
                        underneath (Paul, 2026-08-28). */}
                    {this.yearlyDisplayPrice() != null && (
                      <s className="PremiumMembership-price-was">
                        A${weeklyRate(PRICING_TIERS.premiumYearly.price, "year")}
                      </s>
                    )}
                    A$
                    {weeklyRate(
                      this.yearlyDisplayPrice() != null
                        ? this.yearlyDisplayPrice()
                        : PRICING_TIERS.premiumYearly.price,
                      "year"
                    )}
                    <span className="PremiumMembership-price-period"> a week</span>
                  </div>
                  <div className="PremiumMembership-price-billed">
                    <s>{this.yearlyDisplayPrice() != null ? `A$${PRICING_TIERS.premiumYearly.price}` : "A$600"}</s>{" "}
                    <strong>
                      A${this.yearlyDisplayPrice() != null ? this.yearlyDisplayPrice() : PRICING_TIERS.premiumYearly.price}
                    </strong>
                    , billed yearly
                  </div>
                  <p className="PremiumMembership-yearly-pitch">
                    Best value, and the plan where I can work with you the most.
                  </p>
                  {/* Plain terms on the card itself. Yearly is charged straight
                      away — there is no trial on this plan — so say so here
                      rather than letting anyone find out at checkout. */}
                  <div className="PremiumMembership-termRows PremiumMembership-termRows--gold">
                    <div className="PremiumMembership-termRow">
                      <Icon className="PremiumMembership-termIcon PremiumMembership-termIcon--gold">check_circle</Icon>
                      <span><strong>Full Premium access for the next 12 months</strong> &mdash; every article, video, series and trainer on the site.</span>
                    </div>
                    <div className="PremiumMembership-termRow">
                      <Icon className="PremiumMembership-termIcon PremiumMembership-termIcon--gold">star</Icon>
                      <span><strong>You get me in your corner as your coach for the year</strong> &mdash; ask me anything about your game, and your questions go to the front of the line.</span>
                    </div>
                    <div className="PremiumMembership-termRow">
                      <Icon className="PremiumMembership-termIcon PremiumMembership-termIcon--muted">autorenew</Icon>
                      <span>Renews yearly, and you can cancel any time before then.</span>
                    </div>
                    <div className="PremiumMembership-termRow">
                      <Icon className="PremiumMembership-termIcon PremiumMembership-termIcon--muted">verified_user</Icon>
                      <span>Changed your mind? Tell me within 7 days and I&rsquo;ll refund you in full, no questions asked.</span>
                    </div>
                  </div>

                  <div className="PremiumMembership-tier-benefits">
                    <div className="PremiumMembership-benefit">
                      <Icon className="PremiumMembership-benefit-icon">check_circle</Icon>
                      <span><strong>Everything in Premium</strong> for a full year, plus:</span>
                    </div>
                    <div className="PremiumMembership-benefit">
                      <Icon className="PremiumMembership-benefit-icon">star</Icon>
                      <span><strong>Personalised system review from Paul</strong> - check how you can improve your system, give suggestions for ways to simplify and improve, which conventions to add or remove, and how to improve your signalling</span>
                    </div>
                    <div className="PremiumMembership-benefit">
                      <Icon className="PremiumMembership-benefit-icon">star</Icon>
                      <span><strong>Priority queue for requests</strong> - your questions go to the front of the line, and are regularly turned into new articles and videos on the site, so they get answered comprehensively</span>
                    </div>
                  </div>

                  <button
                    className="PremiumMembership-custom-button PremiumMembership-custom-button-premium"
                    onClick={() => uid ? this.selectTier('premiumYearly') : this.showLogin('premiumYearly')}
                  >
                    {`Get Premium Yearly — ${this.yearlyMonthsFree()} months free`}
                  </button>
                </Card>
              </Col>
            )}
            {/* PREMIUM (monthly) — second row, beside Basic (it leads only when a referral offer hides yearly). Hidden while a yearly-only
                promo is applied. */}
            {this.state.promoYearlyPrice == null && (
            <Col s={12} m={referralPremiumOfferActive ? 12 : 6}>
              <Card className={referralPremiumOfferActive ? "PremiumMembership-pricing-card PremiumMembership-pricing-card-yearly PremiumMembership-pricing-card--hero" : "PremiumMembership-pricing-card PremiumMembership-pricing-card--trial"}>
                <div className={referralPremiumOfferActive ? "PremiumMembership-yearly-badge" : "PremiumMembership-yearly-badge PremiumMembership-yearly-badge--green"}>
                  {referralPremiumOfferActive ? "FIRST MONTH FREE" : `${DEFAULT_TRIAL_DAYS}-DAY FREE TRIAL`}
                </div>
                <h4 className="PremiumMembership-tier-name">Premium</h4>
                <div className="PremiumMembership-price">
                  {isFreeFirstMonthOnPremiumCard ? (
                    <>
                      <s className="PremiumMembership-price-was">
                        A${weeklyRate(PRICING_TIERS.premium.price)}
                      </s>
                      A$0
                      <span className="PremiumMembership-price-period"> first month</span>
                    </>
                  ) : this.state.effectiveMonthlyPrice != null ? (
                    <>
                      <s className="PremiumMembership-price-was">
                        A${weeklyRate(PRICING_TIERS.premium.price)}
                      </s>
                      A${weeklyRate(this.state.effectiveMonthlyPrice)}
                      <span className="PremiumMembership-price-period"> a week</span>
                    </>
                  ) : (
                    <>
                      A${weeklyRate(PRICING_TIERS.premium.price)}
                      <span className="PremiumMembership-price-period"> a week</span>
                    </>
                  )}
                </div>
                <div className="PremiumMembership-price-billed">
                  {isFreeFirstMonthOnPremiumCard ? (
                    <>Then <strong>A${PRICING_TIERS.premium.price}</strong>, billed monthly</>
                  ) : this.state.effectiveMonthlyPrice != null ? (
                    <><s>A${PRICING_TIERS.premium.price}</s> <strong>A${this.state.effectiveMonthlyPrice}</strong>, billed monthly</>
                  ) : (
                    <><strong>A${PRICING_TIERS.premium.price}</strong>, billed monthly</>
                  )}
                </div>
                <div className="PremiumMembership-priceFx">
                  ≈ US$
                  {membershipUsdApproxWhole(
                    this.state.effectiveMonthlyPrice != null
                      ? this.state.effectiveMonthlyPrice
                      : PRICING_TIERS.premium.price
                  )}
                  /month
                </div>

                <div className="PremiumMembership-tier-benefits">
                  <div className="PremiumMembership-benefit">
                    <Icon className="PremiumMembership-benefit-icon">check_circle</Icon>
                    <span><strong>Everything in Basic, plus:</strong></span>
                  </div>
                  <div className="PremiumMembership-benefit">
                    <Icon className="PremiumMembership-benefit-icon">check_circle</Icon>
                    <span><strong>Reels</strong> — unlimited (no daily limit)</span>
                  </div>
                  <div className="PremiumMembership-benefit">
                    <Icon className="PremiumMembership-benefit-icon">check_circle</Icon>
                    <span>Video at the end of every practice hand</span>
                  </div>
                  <div className="PremiumMembership-benefit">
                    <Icon className="PremiumMembership-benefit-icon">check_circle</Icon>
                    <span>Videos to accompany all training problems</span>
                  </div>
                  <div className="PremiumMembership-benefit">
                    <Icon className="PremiumMembership-benefit-icon">check_circle</Icon>
                    <span>Priority response from Paul if you'd like to ask any bridge-related questions</span>
                  </div>
                </div>

                <button
                  className="PremiumMembership-custom-button PremiumMembership-custom-button-premium"
                  onClick={() => uid ? this.selectTier('premium') : this.showLogin('premium')}
                >
                  {referralPremiumOfferActive
                    ? "Start Premium — first month free"
                    : "Start free trial"}
                </button>
              </Card>
            </Col>
            )}

            {/* BASIC TIER (hidden while a yearly-only promo is applied) */}
            {!referralPremiumOfferActive && this.state.promoYearlyPrice == null && (
              <Col s={12} m={6}>
                <Card className="PremiumMembership-pricing-card PremiumMembership-pricing-card--muted">
                  <h4 className="PremiumMembership-tier-name">Basic Membership</h4>
                  <div className="PremiumMembership-price">
                    {isFreeFirstMonthOnBasicCard ? (
                      <>
                        <s className="PremiumMembership-price-was">
                          A${weeklyRate(PRICING_TIERS.basic.price)}
                        </s>
                        A$0
                        <span className="PremiumMembership-price-period"> first month</span>
                      </>
                    ) : (
                      <>
                        A${weeklyRate(PRICING_TIERS.basic.price)}
                        <span className="PremiumMembership-price-period"> a week</span>
                      </>
                    )}
                  </div>
                  <div className="PremiumMembership-price-billed">
                    {isFreeFirstMonthOnBasicCard ? (
                      <>Then <strong>A${PRICING_TIERS.basic.price}</strong>, billed monthly</>
                    ) : (
                      <><strong>A${PRICING_TIERS.basic.price}</strong>, billed monthly</>
                    )}
                  </div>
                  <div className="PremiumMembership-priceFx">
                    ≈ US${membershipUsdApproxWhole(PRICING_TIERS.basic.price)}/month
                  </div>

                  <div className="PremiumMembership-tier-benefits">
                    <div className="PremiumMembership-benefit">
                      <Icon className="PremiumMembership-benefit-icon">check_circle</Icon>
                      <span><strong>Just Play hands</strong> — unlimited</span>
                    </div>
                    <div className="PremiumMembership-benefit">
                      <Icon className="PremiumMembership-benefit-icon">check_circle</Icon>
                      <span><strong>Practice hands</strong> — book-style hands you play against robots, with explanations</span>
                    </div>
                    <div className="PremiumMembership-benefit">
                      <Icon className="PremiumMembership-benefit-icon">check_circle</Icon>
                      <span><strong>Reels</strong> — 30–90 second reels with diagrams and explanations (5 per day)</span>
                    </div>
                    <div className="PremiumMembership-benefit">
                      <Icon className="PremiumMembership-benefit-icon">check_circle</Icon>
                      <span>Full access to all Practical Learning interactive trainers</span>
                    </div>
                    <div className="PremiumMembership-benefit">
                      <Icon className="PremiumMembership-benefit-icon">check_circle</Icon>
                      <span>Access to "The Treadmill"</span>
                    </div>
                  </div>

                  <button
                    className="PremiumMembership-custom-button PremiumMembership-custom-button-basic"
                    onClick={() => uid ? this.selectTier('basic') : this.showLogin('basic')}
                  >
                    Start free trial
                  </button>
                </Card>
              </Col>
            )}

            {/* PREMIUM YEARLY — PARTNERSHIP (two people, A$400 each) */}
            {!referralPremiumOfferActive && this.state.promoYearlyPrice == null && (
              <Col s={12}>
                <Card className="PremiumMembership-pricing-card PremiumMembership-pricing-card-partner">
                  <div className="PremiumMembership-partner-badge">
                    New &mdash; Join With Your Partner &amp; Save
                  </div>
                  <h4 className="PremiumMembership-tier-name">Premium Yearly &mdash; Partnership</h4>
                  <div className="PremiumMembership-price PremiumMembership-price--partner">
                    A${weeklyRate(PRICING_TIERS.premiumYearlyPartnerHalf.price, "year")}
                    <span className="PremiumMembership-price-period"> a week each</span>
                  </div>
                  <div className="PremiumMembership-price-billed">
                    <s>A${PRICING_TIERS.premiumYearly.price}</s>{" "}
                    <strong>A${PRICING_TIERS.premiumYearlyPartnerHalf.price} each</strong>, billed yearly
                  </div>
                  <p className="PremiumMembership-partner-pitch">
                    Everything in Premium Yearly for both of you &mdash; and I work with you as a partnership.
                  </p>

                  <div className="PremiumMembership-partner-live">
                    <span className="PremiumMembership-partner-liveIcon" aria-hidden="true">&clubs;</span>
                    <span className="PremiumMembership-partner-liveTitle">
                      Live session with Paul &mdash; partnership review
                    </span>
                  </div>

                  <div className="PremiumMembership-termRows PremiumMembership-termRows--green">
                    <div className="PremiumMembership-termRow">
                      <Icon className="PremiumMembership-termIcon PremiumMembership-termIcon--green">group</Icon>
                      <span><strong>Two full Premium Yearly memberships</strong> &mdash; everything on the site for both of you, for 12 months.</span>
                    </div>
                    <div className="PremiumMembership-termRow">
                      <Icon className="PremiumMembership-termIcon PremiumMembership-termIcon--green">star</Icon>
                      <span><strong>Live session with me</strong> &mdash; we go over a set of boards your partnership played, with a focus on modern partnership ideas.</span>
                    </div>
                    <div className="PremiumMembership-termRow">
                      <Icon className="PremiumMembership-termIcon PremiumMembership-termIcon--green">payments</Icon>
                      <span><strong>Get $100 off the first year each.</strong></span>
                    </div>
                    <div className="PremiumMembership-termRow">
                      <Icon className="PremiumMembership-termIcon PremiumMembership-termIcon--muted">autorenew</Icon>
                      <span>Renews yearly, cancel any time before then.</span>
                    </div>
                    <div className="PremiumMembership-termRow">
                      <Icon className="PremiumMembership-termIcon PremiumMembership-termIcon--muted">verified_user</Icon>
                      <span>Changed your mind? Tell me within 7 days and I&rsquo;ll refund you in full, no questions asked.</span>
                    </div>
                  </div>

                  <div className="PremiumMembership-partner-payChoice">
                    <div className="PremiumMembership-partner-payLabel">How would you like to pay?</div>
                    <label
                      className={`PremiumMembership-partner-payOpt${this.state.partnershipPayOption === "both" ? " is-selected" : ""}`}
                    >
                      <input
                        type="radio"
                        name="partnershipPay"
                        checked={this.state.partnershipPayOption === "both"}
                        onChange={() => this.setState({ partnershipPayOption: "both" })}
                      />
                      <span>Pay for both of us &mdash; one payment covers your year together</span>
                    </label>
                    <label
                      className={`PremiumMembership-partner-payOpt${this.state.partnershipPayOption === "half" ? " is-selected" : ""}`}
                    >
                      <input
                        type="radio"
                        name="partnershipPay"
                        checked={this.state.partnershipPayOption === "half"}
                        onChange={() => this.setState({ partnershipPayOption: "half" })}
                      />
                      <span>Pay my share only &mdash; my partner pays their own</span>
                    </label>
                  </div>

                  <div className="PremiumMembership-partner-nameField">
                    <label htmlFor="partnershipPartnerName">Your partner&rsquo;s name</label>
                    <input
                      id="partnershipPartnerName"
                      type="text"
                      value={this.state.partnerName}
                      placeholder="e.g. Pat Smith"
                      onChange={(e) => this.setState({ partnerName: e.target.value, partnerNameError: "" })}
                    />
                    <div className="PremiumMembership-partner-nameHint">
                      So I know who you&rsquo;re playing with &mdash; it links your two memberships and your review session.
                    </div>
                    {this.state.partnerNameError && (
                      <div className="PremiumMembership-partner-nameError">{this.state.partnerNameError}</div>
                    )}
                  </div>

                  <button
                    className="PremiumMembership-custom-button PremiumMembership-custom-button-partner"
                    onClick={this.selectPartnershipTier}
                  >
                    {this.state.partnershipPayOption === "half"
                      ? "Join — my share"
                      : "Join with my partner"}
                  </button>
                </Card>
              </Col>
            )}

          </Row>
        )}

        {/* PROMO CODE INPUT — below the plans (front-door review 2026-09-04),
            so the hint copy says "above". Also shown on the payment step, so
            a code can still be typed after picking a plan. */}
        {!referralPremiumOfferActive && !showLogin && (showBothTiers || showTierSelection) && (
          <Row>
            <Col s={12} m={8} l={6} offset="m2 l3" style={{ marginTop: "0.5rem", marginBottom: "1rem" }}>
              <div className="PremiumMembership-promoShell">
                <label className="PremiumMembership-promoLabel">
                  Have a promo code? (Optional)
                </label>
                <input
                  type="text"
                  placeholder="Enter promo code"
                  value={this.state.promoCode}
                  onChange={this.handlePromoCodeChange}
                  onKeyDown={this.handlePromoCodeKeyDown}
                  onBlur={this.handlePromoCodeBlur}
                  className="PremiumMembership-promo-input-large"
                />
                {this.state.promoError && (
                  <div className="PremiumMembership-promoError">
                    {this.state.promoError}
                  </div>
                )}
                {this.state.promoSuccess && (
                  <div className="PremiumMembership-promoSuccess">
                    {this.state.promoSuccess}
                  </div>
                )}
                {this.state.promoSuccess && (
                  <div className="PremiumMembership-promoNextStep">
                    {this.state.effectiveMonthlyPrice != null
                      ? `Next step: choose Premium above, then complete checkout — your rate will be A$${this.state.effectiveMonthlyPrice}/month after the ${DEFAULT_TRIAL_DAYS}-day free trial (about US$${membershipUsdApproxWhole(this.state.effectiveMonthlyPrice)}/month at typical FX; your bank sets the rate).`
                      : this.state.promoDaysFree > 0
                        ? "Next step: choose a plan above, then complete checkout — your code adds the free time shown above before regular billing."
                        : "Next step: choose a plan above, then complete checkout — your code will be applied at checkout."}
                  </div>
                )}
              </div>
            </Col>
          </Row>
        )}

        {/* Membership terms. Stated once, at the point of purchase, and
            phrased so the rule points at the Partnership plan rather than
            just saying no. */}
        {showBothTiers && (
          <Row>
            <Col s={12}>
              <div className="PremiumMembership-terms">
                <div className="PremiumMembership-terms-title">Membership terms</div>
                <p>
                  Your membership is personal to you. Accounts are for one person and
                  should not be shared &mdash; each player needs their own membership.
                </p>
                <p>
                  Playing with a regular partner? The <strong>Premium Yearly Partnership</strong>
                  {" "}option above covers both of you, at A$400 each.
                </p>
              </div>
            </Col>

          </Row>
        )}

        {/* PAYMENT SECTION FOR LOGGED IN USERS */}
        {showTierSelection && (
          <Row>
            <Col s={12}>
              <Card className="PremiumMembership-payment-card">
                <div className="PremiumMembership-payment-header">
                  <h4>{PRICING_TIERS[selectedTier].name}</h4>
                  <div className="PremiumMembership-payment-price">
                    {isFreeFirstMonthAppliedOnSelectedTier ? (
                      <>
                        <span style={{ textDecoration: "line-through", opacity: 0.65, marginRight: "0.35em" }}>
                          A${selectedTierBasePrice}
                        </span>
                        <span>A$0 for the first month</span>
                        <span className="PremiumMembership-payment-priceFx"> Then A${selectedTierBasePrice}/{PRICING_TIERS[selectedTier].period === "year" ? "year" : "month"}.</span>
                      </>
                    ) : (
                      <>
                        A$
                        {selectedTier === "premium" && this.state.effectiveMonthlyPrice != null
                          ? this.state.effectiveMonthlyPrice
                          : selectedTier === "premiumYearly" && this.yearlyDisplayPrice() != null
                            ? this.yearlyDisplayPrice()
                            : PRICING_TIERS[selectedTier].price}{" "}
                        <span>
                          {isYearlySelected
                            ? promoTrialDays > 0
                              ? `for 12 months — A$0 today, first charge ${firstChargeDateStr}`
                              : "for 12 months, charged today"
                            : `per month after ${DEFAULT_TRIAL_DAYS} days free`}
                        </span>
                        {PRICING_TIERS[selectedTier].period === "year" ? (
                          <span className="PremiumMembership-payment-priceFx"> ({this.yearlyMonthsFree()} months free vs A$50/month)</span>
                        ) : paymentUsdForFx != null ? (
                          <span className="PremiumMembership-payment-priceFx">
                            {" "}
                            (about US${paymentUsdForFx}/month at typical FX; your bank sets the rate)
                          </span>
                        ) : null}
                      </>
                    )}
                  </div>
                </div>
                
                <div className="PremiumMembership-payment-actions">
                  <button
                    className="PremiumMembership-change-tier-btn"
                    onClick={() => this.setState({ selectedTier: null })}
                  >
                    ← Change Tier
                  </button>
                </div>

                {this.state.promoCode && this.state.promoSuccess && (
                  <div
                    style={{
                      marginBottom: "1rem",
                      padding: "0.75rem 1rem",
                      background: "#e8f5e9",
                      borderRadius: "6px",
                      fontSize: "var(--text-sm)",
                    }}
                  >
                    <strong>Promo:</strong>{" "}
                    {this.isPremiumOnlyFreeMonthPromo(this.state.promoCode) && selectedTier !== "premium" ? (
                      <>
                        {this.state.promoCode.toUpperCase()} is for <strong>Premium</strong> only. Tap{" "}
                        <strong>← Change Tier</strong> and choose Premium to use it.
                      </>
                    ) : isFreeFirstMonthAppliedOnSelectedTier ? (
                      <>
                        {this.state.promoCode.toUpperCase()} applied. Your first 30 days are free, then A$
                        {selectedTierBasePrice}/{PRICING_TIERS[selectedTier].period === "year" ? "year" : "month"} unless canceled.
                      </>
                    ) : this.state.effectiveMonthlyPrice != null && selectedTier !== "premium" ? (
                      <>
                        {this.state.promoCode.toUpperCase()} is for <strong>Premium</strong> at A$
                        {this.state.effectiveMonthlyPrice}/month after your free trial (about US$
                        {membershipUsdApproxWhole(this.state.effectiveMonthlyPrice)} at typical FX) — tap{" "}
                        <strong>← Change Tier</strong> and choose Premium to use it.
                      </>
                    ) : selectedTier === "premium" && this.state.effectiveMonthlyPrice != null ? (
                      <>
                        {this.state.promoCode.toUpperCase()} — you&apos;ll be charged A$
                        {this.state.effectiveMonthlyPrice}/month after your {DEFAULT_TRIAL_DAYS}-day free trial (not the
                        standard A${PRICING_TIERS.premium.price}/month; about US$
                        {membershipUsdApproxWhole(this.state.effectiveMonthlyPrice)} at typical FX).
                      </>
                    ) : isYearlySelected && this.yearlyDisplayPrice() != null ? (
                      <>
                        {this.state.promoCode.toUpperCase()} —{" "}
                        {promoTrialDays > 0
                          ? `A$0 today. Your first charge is A$${yearlyNowPrice} on ${firstChargeDateStr}`
                          : `A$${yearlyNowPrice} today`}
                        {yearlyRenewalPrice === yearlyNowPrice
                          ? `, then A$${yearlyRenewalPrice} every year unless canceled.`
                          : `, then A$${yearlyRenewalPrice} a year after that unless canceled.`}
                      </>
                    ) : this.state.promoDaysFree > 0 ? (
                      <>
                        {this.state.promoCode.toUpperCase()} — adds {this.state.promoDaysFree} free day
                        {this.state.promoDaysFree !== 1 ? "s" : ""} before billing (on top of the usual trial where applicable).
                      </>
                    ) : this.isExtendedTrialStandardPricePromo(this.state.promoCode) ? (
                      <>
                        {this.state.promoCode.toUpperCase()} — extends your free period before paid billing starts.
                        Your ongoing rate stays the normal price for this tier (A${PRICING_TIERS[selectedTier].price}/
                        {PRICING_TIERS[selectedTier].period === "year" ? "year" : "month"},
                        about US${membershipUsdApproxWhole(PRICING_TIERS[selectedTier].price)} at typical FX); this code does
                        not lower the amount.
                      </>
                    ) : (
                      <>{this.state.promoCode.toUpperCase()} will be applied when you complete checkout.</>
                    )}
                  </div>
                )}
                {referralPremiumOfferActive && selectedTier === "premium" && (
                  <div
                    style={{
                      marginBottom: "1rem",
                      padding: "0.75rem 1rem",
                      background: "#e8f5e9",
                      borderRadius: "6px",
                      fontSize: "var(--text-sm)",
                    }}
                  >
                    <strong>Referral active:</strong> referred by {referralReferrerName}. You get 1 month of
                    Premium free (A$0 first month), then normal Premium billing.
                  </div>
                )}
                {!this.state.promoCode && !referralPremiumOfferActive && !isYearlySelected && (
                  <div
                    style={{
                      marginBottom: "1rem",
                      padding: "0.75rem 1rem",
                      background: "#e8f5e9",
                      borderRadius: "6px",
                      fontSize: "var(--text-sm)",
                    }}
                  >
                    <strong>Free trial included:</strong> Your first {DEFAULT_TRIAL_DAYS} days are free.
                  </div>
                )}

                <div className="PremiumMembership-payment-options">
                  <div className="PremiumMembership-payment-divider">
                    <span>Secure card checkout</span>
                  </div>
                  
                  <div className="PremiumMembership-payment-methods">
                    <div className="PremiumMembership-payment-method">
                      <div className="PremiumMembership-payment-method-header">
                        <i className="fab fa-cc-stripe" style={{ fontSize: '2rem', color: '#635bff', marginRight: '0.5rem' }}></i>
                        <span>Official Stripe Checkout</span>
                      </div>
                      <p className="PremiumMembership-trialLead">
                        {isFreeFirstMonthAppliedOnSelectedTier ? (
                          <>
                            <strong>
                              {referralPremiumOfferActive ? "Referral applied:" : `${this.state.promoCode.toUpperCase()} applied:`}
                            </strong>{" "}
                            first month A$0, then A${selectedTierBasePrice}/{PRICING_TIERS[selectedTier].period === "year" ? "year" : "month"} unless canceled.
                          </>
                        ) : (
                          <>
                            {isYearlySelected ? (
                              selectedTier === "premiumYearlyPartnerBoth" ? (
                                <>
                                  <strong>2 &times; A${PRICING_TIERS.premiumYearlyPartnerHalf.price} (A${PRICING_TIERS.premiumYearlyPartnerBoth.price}) today</strong> &mdash; covers both memberships, then 2 &times; A${PRICING_TIERS.premiumYearlyPartnerHalf.renewalPrice} (A${PRICING_TIERS.premiumYearlyPartnerBoth.renewalPrice}) in 12 months unless canceled
                                </>
                              ) : selectedTier === "premiumYearlyPartnerHalf" ? (
                                <>
                                  <strong>A${PRICING_TIERS.premiumYearlyPartnerHalf.price} today &mdash; your share</strong>, then A${PRICING_TIERS.premiumYearlyPartnerHalf.renewalPrice} in 12 months unless canceled. Your partner pays their A${PRICING_TIERS.premiumYearlyPartnerHalf.price} separately.
                                </>
                              ) : (
                              <>
                                {/* Both figures are derived, never assumed. Twice now they were
                                    not: on 31 Aug 2026 this printed the LIST price for both, so
                                    a member with a yearly code was told "A$500 today" while
                                    Stripe charged A$400, and abandoned checkout twice. On 3 Sep
                                    2026 it said "A$300 today, then A$500" for CLUBHOUSE, which
                                    charges nothing today and A$300 forever. A club code renews
                                    at list because its coupon is duration:once; a code that
                                    overrides the price renews at the discount. Saying the real
                                    renewal here is also more honest than revealing it a year
                                    later. Verify with scripts/_audit-promo-tokens.js. */}
                                {promoTrialDays > 0 ? (
                                  <>
                                    <strong>A$0 today</strong>, then A${yearlyNowPrice} on{" "}
                                    {firstChargeDateStr}, and A${yearlyRenewalPrice} a year after that
                                    unless canceled
                                  </>
                                ) : (
                                  <>
                                    <strong>A${yearlyNowPrice} today</strong>, then A$
                                    {yearlyRenewalPrice} in 12 months unless canceled
                                  </>
                                )}
                              </>
                              )
                            ) : (
                              <>
                                <strong>{DEFAULT_TRIAL_DAYS} days free today</strong>, then A$
                                {selectedTier === "premium" && this.state.effectiveMonthlyPrice != null
                                  ? this.state.effectiveMonthlyPrice
                                  : PRICING_TIERS[selectedTier].price}
                                /month unless canceled
                              </>
                            )}
                            {PRICING_TIERS[selectedTier].period !== "year" && paymentUsdForFx != null
                              ? ` (about US$${paymentUsdForFx}/month at typical FX; your bank sets the rate)`
                              : ""}
                            .
                          </>
                        )}
                      </p>
                      <p className="PremiumMembership-trialSub">
                        Secure card payment powered by Stripe.
                      </p>
                      <StripeCheckout
                        uid={this.props.uid}
                        email={this.props.email}
                        tierPriceId={
                          selectedTier === "premium" && this.state.effectiveStripePriceId && this.state.promoYearlyPrice == null
                            ? this.state.effectiveStripePriceId
                            : selectedTier === "premiumYearly" && this.state.promoYearlyPrice != null && this.state.effectiveStripePriceId
                              ? this.state.effectiveStripePriceId
                              : PRICING_TIERS[selectedTier].stripePriceId
                        }
                        tierName={PRICING_TIERS[selectedTier].name}
                        tierPrice={String(
                          selectedTier === "premium" && this.state.effectiveMonthlyPrice != null
                            ? this.state.effectiveMonthlyPrice
                            : selectedTier === "premiumYearly" && this.yearlyDisplayPrice() != null
                              ? this.yearlyDisplayPrice()
                              : PRICING_TIERS[selectedTier].price
                        )}
                        getToken={this.getAppliedPromoToken}
                        isYearly={selectedTier === "premiumYearly"}
                        getEnteredPromoCode={() =>
                          referralPremiumOfferActive
                            ? this.normalizePromoCode(this.state.referralCodeFromLink)
                            : this.normalizePromoCode(this.state.promoCode)
                        }
                        buttonTitle={
                          selectedTier === "premiumYearlyPartnerBoth"
                            ? "Join with my partner"
                            : selectedTier === "premiumYearlyPartnerHalf"
                              ? "Join — my share"
                              : undefined
                        }
                        processing={() => {
                          // Belt and braces: the partner's name is written at
                          // card-click time, but re-record here so the login-
                          // first path can never lose it.
                          if (isPartnershipTier(selectedTier)) this.recordPartnershipDetails();
                          this.setState({ stripeProcessing: true });
                        }}
                        clearProcessing={() => this.setState({ stripeProcessing: false })}
                        changeSubscriptionActiveStatus={this.props.changeSubscriptionActiveStatus}
                        history={this.props.history}
                        redirectAfterCheckout={redirectAfterCheckout}
                      />
                    </div>
                  </div>

                  <div className="PremiumMembership-secure-badge">
                    <i className="fas fa-lock"></i> Secure Checkout
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        )}

        {(paypalRedirectLoading || this.state.stripeProcessing) && (
          <Row className="PremiumMembership-loading">
            <div className="center-align">
              <Preloader flashing size="big" />
              <br />
              <p>{paypalRedirectLoading ? 'Transferring you to PayPal.com now....' : 'Processing your payment...'}</p>
            </div>
          </Row>
        )}
      </div>
    );
  }
}

export default connect(
  ({ auth }) => ({
    uid: auth.uid,
    authReady: !!auth.authReady,
    email: auth.email,
    subscriptionExpires: auth.subscriptionExpires,
    subscriptionActive: auth.subscriptionActive,
    trialUsed: auth.trialUsed,
    tier: auth.tier ?? "basic",
    paymentMethod: auth.paymentMethod,
  }),
  { changeSubscriptionActiveStatus }
)(PremiumMembership);
